"use client";

import { useTranslation } from "@/hooks/useTranslation";

export default function TermsAndConditionsContent() {
	const { t } = useTranslation();

	const sections = [
		"section1",
		"section2",
		"section3",
		"section4",
		"section5",
		"section6",
		"section7",
		"section8",
		"section9",
	];

	return (
		<div className="space-y-6">
			{sections.map((section) => (
				<div key={section} className="space-y-2">
					<h3 className="text-lg font-semibold text-gray-900">
						{t(`terms.content.${section}.title`)}
					</h3>
					<p className="text-gray-700 leading-relaxed">
						{t(`terms.content.${section}.text`)}
					</p>
				</div>
			))}
		</div>
	);
}